import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Menu, Button, Row, Dropdown } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './CustomerMainLayout.scss';
import FileConstants from '../../../../FileConstants';
import homeBlack from './blackHome.svg';
import homeRed from './redHome.svg';
import redbar from './redbar.svg'
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = ({ selected, history, location }) => {
  const [selectedKey, setSelectedKey] = useState(selected);
  const [hoverKey, setHoverKey] = useState(null);
  const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
  const [latestContract, setLatestContract] = useState(null);
  const isAiCustomer = localStorage.getItem('is_ai_customer') === 'true';
  const [openKeys, setOpenKeys] = useState([]);
  const [hasProps, setHasProps] = useState(false);
  const [hasInspirations, setHasInspirations] = useState(false);

  const handleMouseEnter = key => {
    setHoverKey(key);
  };

  const handleMouseLeave = () => {
    setHoverKey(null);
  };


  useEffect(() => {
      setSelectedKey(selected);
      // Keep AI Creator submenu open if one of its items is selected
      if (['26', '30'].includes(selected)) {
        setOpenKeys(['ai-creator']);
      }
  }, [selected, isAiCustomer, location.pathname]);

  useEffect(() => {
    if(MANAGED_COMPANY_ID){
      let payload = {
        action: 'get_company_latest_contract',
        company_id: `${MANAGED_COMPANY_ID}`
      }
      axios.post(ENVIRONMENT.CUSTOMER_CONTRACT_CONTROLLER, payload)
        .then(res => {
          if (res.data && typeof res.data === "object" && !(Array.isArray(res.data) && res.data.length === 0)) {
            setLatestContract(res.data);
        }      
        })
    }
  }, [])

  useEffect(() => {
    let customerUsername = localStorage.getItem('username');
    let companyId = localStorage.getItem('company_id');

    const cachedHasProps = localStorage.getItem('has_props');
    const cachedHasInspirations = localStorage.getItem('has_inspirations');


    if (cachedHasInspirations === 'true') {
      setHasInspirations(true);
    }

    if (cachedHasProps === 'true') {
      setHasProps(true);
    } else if (customerUsername) {
      axios.post(ENVIRONMENT.AI_MODEL_HELPER, {
        action: 'check_user_has_props',
        username: customerUsername,
        company_id: companyId
      })
        .then(res => {
          const hasPropsValue = res.data && res.data.result === 'success' && res.data.has_props;
          setHasProps(hasPropsValue);
          localStorage.setItem('has_props', hasPropsValue ? 'true' : 'false');
        })
        .catch(() => {
          setHasProps(false);
          localStorage.setItem('has_props', 'false');
        });
    }
    if (cachedHasInspirations === 'true') {
      setHasInspirations(true);
    } else if (customerUsername) {
      axios.post(ENVIRONMENT.AI_MODEL_HELPER, {
        action: 'check_user_has_inspirations',
        username: customerUsername,
        company_id: companyId
      })
        .then(res => {
          const hasInspirationsValue = res.data && res.data.result === 'success' && res.data.has_inspirations;
          setHasInspirations(hasInspirationsValue);
          localStorage.setItem('has_inspirations', hasInspirationsValue ? 'true' : 'false');
        })
        .catch(() => {
          setHasInspirations(false);
          localStorage.setItem('has_inspirations', 'false');
        });
    }

  }, [localStorage.getItem('username'), localStorage.getItem('company_id')])


  const handleMenuItemChange = (e) => {
    const routes = {
      1: '/add_product',
      2: '/create_room',
      3: '/list-products',
      5: '/rooms',
      6: '/my_scenes',
      7: '/tags?selected=7',
      8: '/modeling?selected=8',
      9: '/home',
      11: '/store?selected=11',
      12: '/about?selected=12',
      13: '/list-collections',
      14: '/library-projects',
      15: '/help',
      16: '/material-library',
      17: '/account-usage',
      18: '/customer_model_report',
      19: '/bulk-configurations',
      20: '/collaborations',
      21: '/projects',
      25: '/images',
      26: '/ai-asset-creator',
      27: '/integrations',
      31: '/review-images',
      29: '/groups',
      30: '/ai-model-creator',
      33: '/account-details?tab=company-users',
      34: '/props-library',
      36: '/inspiration-images',
      37: '/brand-guidelines',
      38: '/explore'
    };

    if(MANAGED_COMPANY_ID && latestContract){
      routes[28] = `/customer_contract_form?action=view&contract_id=${latestContract.id}`
    }
    if (routes[e.key]) {
      // history.push(routes[e.key]);
      // setSelectedKey(e.key);
      window.location.href = routes[e.key];
    }
  };

  const handleCreateNewFormChange = (e) => {
    const current_page = location.pathname;
    const routes = {
      1: '/upload-product-model?origin=',
      2: '/add-new-room?origin=',
      3: '/create-empty-scene?origin=',
      4: '/create-scene-from-template?origin=',
      5: '/create-new-material?origin=',
      6: '/upload-scanned-material?origin=',
      7: '/bulk-product-config-create?origin=',
      8: '/create-ai-product?origin=',
      9: '/add-new-product?origin=',
      10: '/new_project?origin=',
      11: '/ai-model-creator?origin=',
      12: '/ai-asset-creator?open_bulk_modal=true&origin='
    };

    if (e.key === '11') {
      localStorage.removeItem("ai_product_id");
      localStorage.removeItem("ai_generation_step");
    }

    if (routes[e.key]) {
      window.location.href = routes[e.key] + current_page;
    }
  };

  const menu = (
    <Menu triggerSubMenuAction="hover">
      <SubMenu title={<span className='manrope f-14'>Product</span>} popupOffset={[0, 0]}>

        <SubMenu title={<span className='manrope f-14'>Create Photorealistic 3D Model</span>} popupOffset={[0, 0]}>
          <Menu.Item key="8" onClick={handleCreateNewFormChange}>
            <span className='manrope f-14'>From Product Images</span>
          </Menu.Item>
          <Menu.Item key="9" onClick={handleCreateNewFormChange}>
            <span className='manrope f-14'>From CAD or Sketch</span>
          </Menu.Item>
        </SubMenu>

        <Menu.Item key="11" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>Create AI 3D Model</span>
        </Menu.Item>
        <Menu.Item key="1" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>Upload Existing Model</span>
        </Menu.Item>
        <Menu.Item key="12" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>Bulk Create AI Images</span>
        </Menu.Item>

        {/* <SubMenu title={<span>Create New Model</span>} popupOffset={[0, 0]}>
          <Menu.Item key="8" onClick={handleCreateNewFormChange}>
            <span>Existing Physical Product</span>
          </Menu.Item>
          <Menu.Item key="9" onClick={handleCreateNewFormChange}>
            <span>Design A New Product</span>
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="1" onClick={handleCreateNewFormChange}>
          <span>Upload Existing Model</span>
        </Menu.Item>
        <Menu.Item key="11" onClick={handleCreateNewFormChange}>
          <span>AI Model</span>
        </Menu.Item> */}
      </SubMenu>
      {!isAiCustomer && <>
      <Menu.Item key="2" onClick={handleCreateNewFormChange}>
        <span className='manrope f-14'>Space</span>
      </Menu.Item>
      <SubMenu title={<span className='manrope f-14'>Scene</span>} popupOffset={[0, 0]}>
        <Menu.Item key="3" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>From Empty Space</span>
        </Menu.Item>
        <Menu.Item key="4" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>From Template</span>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key="10" onClick={handleCreateNewFormChange}>
        <span className='manrope f-14'>Project</span>
      </Menu.Item>
      <SubMenu title={<span>Material</span>} popupOffset={[0, 0]}>
        <Menu.Item key="5" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>Create New Material</span>
        </Menu.Item>
        <Menu.Item key="6" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'>Upload Scanned Material</span>
        </Menu.Item>
      </SubMenu>
      {FileConstants.BULK_REQUEST_ELIGIBLE_COMPANIES.includes(localStorage.getItem('company_id')) && (
        <Menu.Item key="7" onClick={handleCreateNewFormChange}>
          <span className='manrope f-14'> Bulk Request</span>
        </Menu.Item>
      )}
      
      </>}
      {/* <Menu.Item key="11" onClick={handleCreateNewFormChange}>
        <span>Use AI Creator</span>
      </Menu.Item> */}
    </Menu>
  );

  const aiCustomerCreateMenu = (
        <Menu triggerSubMenuAction="hover">
          <Menu.Item key="6" onClick={() => window.location.href = '/ai-asset-creator?open_product_modal=true'}>
            <span className='manrope f-14'>Product Images</span>
          </Menu.Item>
          <Menu.Item key="6" onClick={() => window.location.href = '/ai-asset-creator?open_bulk_modal=true'}>
            <span className='manrope f-14'>Bulk Upload</span>
          </Menu.Item>
        </Menu>
  )

  return (
    <Sider className='antSider'id='uniqueSidebar'>
      <Row className="create-new-button-container">
        {!isAiCustomer ? <Dropdown overlay={menu} trigger={['hover']}>
          <Button
            className="create-new-button justify-in-center modal-okay-cblack square font-14"
            shape="circle"
            size="default"
          >
            <PlusOutlined />
            Create New
          </Button>
        </Dropdown> : 
        <Dropdown overlay={aiCustomerCreateMenu} trigger={['hover']}>
          <Button
          className="create-new-button justify-in-center modal-okay-cblack square font-14"
          shape="circle"
          size="default"
          >
          <PlusOutlined />
          Create New
        </Button>
      </Dropdown>
      }
      </Row>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[selectedKey]}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        style={{ marginBottom: '5%' }}
      >
      {!isAiCustomer &&
        <Menu.Item
        key="9"
        className='home-menu-item'
        onClick={handleMenuItemChange}
        onMouseEnter={() => handleMouseEnter('9')}
        onMouseLeave={handleMouseLeave}
        style={{ marginTop: '24px', marginBottom: '24px', padding: 0 }} // Consistent padding
      >
        {selectedKey === '9' && (
          <img
            src={redbar}
            alt="Red Bar"
            style={{
              position: 'absolute',
              left: 6,
              top: 0,
              bottom: 0,
              width: '5px',
              height: '90%',
              objectFit: 'contain',
            }}
          />
        )}
          <img
          src={selectedKey === '9' || hoverKey === '9' ? homeRed : homeBlack}
          alt="Home Icon"
          style={{ 
            marginRight: 2, 
            marginLeft:-5,
            width: '14px',   
            height: '14px',  
            objectFit: 'contain',
          }}
        />

        <span
          className="manrope f-14 w-600"
          style={{
            marginLeft: '2px', lineHeight: "10px"
          }}
        >
          Home
        </span>
      </Menu.Item>}

        <div style={{ marginBottom: '0px', paddingLeft: 20, marginTop: '20px' }}>
          <span style={{ color: 'grey', justifyContent: 'center', alignItems: 'center' }} className="manrope f-12 w-400">
            Workflow
          </span>
        </div>
        {!isAiCustomer && <Menu.Item key="21" onClick={handleMenuItemChange} style={{ marginBottom: '0px',marginTop:10 }}>
        {selectedKey === '21' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%', 
            objectFit: 'contain',
          }}

            />
          )}
          <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Active Projects</span>
        </Menu.Item>}
        {!isAiCustomer && <Menu.Item key="6" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '6' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%', 
            objectFit: 'contain',
          }}

            />
          )}
          <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Scenes</span>
        </Menu.Item>}
        
        {!isAiCustomer && <SubMenu 
          key="ai-creator"
          className='ai-creator-submenu'
          title={
            <span 
              className="manrope f-14 w-600" 
              style={{ fontWeight: openKeys.includes('ai-creator') ? 700 : 600 }}
            >
              AI Creator
            </span>
          }
          style={{ marginBottom: '0px', marginTop: '5px' }}
        >
          <Menu.Item key="26" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '26' && (
              <img
                src={redbar}
                alt="Red Bar"
                style={{
                  position: 'absolute',
                  left: 6,
                  top: 0,
                  bottom: 0,
                  width: '5px',
                  height: '90%',
                  objectFit: 'contain',
                }}
              />
            )}
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
              <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>AI Images</span>
            </span>
          </Menu.Item>
          
            <Menu.Item key="30" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
              {selectedKey === '30' && (
                <img
                  src={redbar}
                  alt="Red Bar"
                  style={{
                    position: 'absolute',
                    left: 6,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    height: '90%',
                    objectFit: 'contain',
                  }}
                />
              )}
              <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                <span 
                  className="manrope f-14 w-600" 
                  style={{
                    marginLeft:'-5px',
                    color: selectedKey === '30' ? '#D93025' : 'inherit'
                  }}
                >
                  AI 3D Models
                </span>
              </span>
            </Menu.Item>
          
        </SubMenu>}

        {isAiCustomer && <Menu.Item key="26" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '26' && (
              <img
                src={redbar}
                alt="Red Bar"
                style={{
                  position: 'absolute',
                  left: 6,
                  top: 0,
                  bottom: 0,
                  width: '5px',
                  height: '90%',
                  objectFit: 'contain',
                }}
              />
            )}
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
              <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>AI Creator</span>
            </span>
          </Menu.Item>}
        
        <Menu.Item key="38" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
          {selectedKey === '38' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%',
                objectFit: 'contain',
              }}
            />
          )}
          <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Explore</span>
          </span>
        </Menu.Item>

        <Menu.Item key="25" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '25' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%',
            objectFit: 'contain',
          }}
            />
          )}
          <span  style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Gallery</span>
          </span>
        </Menu.Item>
        <Menu.Item key="31" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '31' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%',
            objectFit: 'contain',
          }}
            />
          )}
          <span  style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Review Center</span>
          </span>
        </Menu.Item>
        <Menu.Item key="20" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '20' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%', 
            objectFit: 'contain',
          }}

            />
          )}
          <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Collaborations</span>
        </Menu.Item>
        {FileConstants.BULK_REQUEST_ELIGIBLE_COMPANIES.includes(localStorage.getItem('company_id')) && !isAiCustomer &&
          <Menu.Item key="19" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '19' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%', 
            objectFit: 'contain',
          }}

            />
          )}
            <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Bulk Requests</span>
          </Menu.Item>
        }
        <div style={{ marginBottom: '0px', paddingLeft: 20, marginTop: '32px' }}>
          <span style={{ color: 'grey', justifyContent: 'center', alignItems: 'center' }} className="manrope f-12 w-400">
            Libraries
          </span>
        </div>
        <Menu.Item key="3" onClick={handleMenuItemChange} style={{ marginBottom: '0px',marginTop:'10px' }}>
        {selectedKey === '3' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '3px',
            height: '90%', 
            objectFit: 'contain',
          }}
            />
          )}
          <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Products</span>
        </Menu.Item>
        {!isAiCustomer && (
          <>
            <Menu.Item key="5" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '5' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%',
                objectFit: 'contain',
              }}
                />
              )}
              <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Spaces</span>
            </Menu.Item>
            <Menu.Item key="16" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '16' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%', 
                objectFit: 'contain',
              }}
                />
              )}
              <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Materials</span>
            </Menu.Item>
            <Menu.Item key="14" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
            {selectedKey === '14' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%',
                objectFit: 'contain',
              }}
                />
              )}<span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Projects</span>
            </Menu.Item>
            {localStorage.getItem("is_msprovider") === 'true' && 
              <Menu.Item key="13" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
               {selectedKey === '13' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%', 
                objectFit: 'contain', 
              }}
                />
              )}
                <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Collections</span>
              </Menu.Item>
            }
          </>
        )}
        {hasProps && <Menu.Item key="34" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '34' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%',
            objectFit: 'contain',
          }}
            />
          )}
          <span  style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Props</span>
          </span>
        </Menu.Item>}
        {hasInspirations && <Menu.Item key="36" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
        {selectedKey === '36' && (
        <img
          src={redbar}
          alt="Red Bar"
          style={{
            position: 'absolute',
            left: 6,
            top: 0,
            bottom: 0,
            width: '5px',
            height: '90%',
            objectFit: 'contain',
          }}
            />
          )}
          <span  style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <span className="manrope f-14 w-600" style={{marginLeft:'-5px'}}>Inspiration</span>
          </span>
        </Menu.Item>}
        {(
          <>
            <div style={{ marginBottom: '0px', paddingLeft: 20, marginTop: '32px' }}>
              <span style={{ color: 'grey', justifyContent: 'center', alignItems: 'center' }} className="manrope f-12 w-400">
                Platform
              </span>
            </div>
            
            {!isAiCustomer && <Menu.Item key="17" onClick={handleMenuItemChange} style={{ marginBottom: '0px',marginTop:5 }}>
            {selectedKey === '17' && (
            <img
              src={redbar}
              alt="Red Bar"
              style={{
                position: 'absolute',
                left: 6,
                top: 0,
                bottom: 0,
                width: '5px',
                height: '90%', 
                objectFit: 'contain',
              }}
                />
              )}
              <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Usage History</span>
            </Menu.Item>}
            <Menu.Item key="33" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: 5 }}>
              {selectedKey === '33' && (
                <img
                  src={redbar}
                  alt="Red Bar"
                  style={{
                    position: 'absolute',
                    left: 6,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    height: '90%',
                    objectFit: 'contain',
                  }}
                />
              )}
              <span className="manrope f-14 w-600" style={{ marginLeft: '-5px' }}>Users</span>
            </Menu.Item>
            <Menu.Item key="27" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: 5 }}>
              {selectedKey === '27' && (
                <img
                  src={redbar}
                  alt="Red Bar"
                  style={{
                    position: 'absolute',
                    left: 6,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    height: '90%',
                    objectFit: 'contain',
                  }}
                />
              )}
              <span className="manrope f-14 w-600" style={{ marginLeft: '-5px' }}>Integrations</span>
            </Menu.Item>
            {/* <Menu.Item key="37" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: 5 }}>
              {selectedKey === '37' && (
                <img
                  src={redbar}
                  alt="Red Bar"
                  style={{
                    position: 'absolute',
                    left: 6,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    height: '90%',
                    objectFit: 'contain',
                  }}
                />
              )}
              <span className="manrope f-14 w-600" style={{ marginLeft: '-5px' }}>Brand Guidelines</span>
            </Menu.Item> */}

                {localStorage.getItem("is_msprovider") === 'true' && 
                  <Menu.Item key="18" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
                   {selectedKey === '18' && (
                <img
                  src={redbar}
                  alt="Red Bar"
                  style={{
                    position: 'absolute',
                    left: 6,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    height: '90%', 
                    objectFit: 'contain', 
                  }}
                    />
                  )}
                    <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Customer Reports</span>
                  </Menu.Item>
                }

                {
                  MANAGED_COMPANY_ID && latestContract &&
                  <Menu.Item key="28" onClick={handleMenuItemChange} style={{ marginBottom: '0px', marginTop: '5px' }}>
                   {selectedKey === '28' && (
                  <img
                    src={redbar}
                    alt="Red Bar"
                    style={{
                      position: 'absolute',
                      left: 6,
                      top: 0,
                      bottom: 0,
                      width: '5px',
                      height: '90%', 
                      objectFit: 'contain', 
                    }}
                      />
                    )}
                      <span className="manrope f-14 w-600"style={{marginLeft:'-5px'}}>Contracts</span>
                    </Menu.Item>

                }
          </>
        )}
      </Menu>
      
    </Sider>
  );
};

export default withRouter(Sidebar);
